import I18n from 'I18n';
import { createAction } from 'redux-actions';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import getGuid from 'ui-forms-editor-automation-lib/selectors/getGuid';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
import SOURCE_APP from 'ui-forms-editor-automation-lib/constants/SOURCE_APP';
import postAddNewFollowUpEmail from 'ui-forms-editor-automation-lib/api/postAddNewFollowUpEmail';
import createErrorAction from 'ui-forms-editor-automation-lib/utils/createErrorAction';
export const REQUEST_CREATE_FOLLOW_UP = '@@lib/REQUEST_CREATE_FOLLOW_UP';
export const SUCCESS_CREATING_FOLLOW_UP = '@@lib/SUCCESS_CREATING_FOLLOW_UP';
export const FAIL_CREATING_FOLLOW_UP = '@@lib/FAIL_CREATING_FOLLOW_UP';
export const requestCreateFollowUp = createAction(REQUEST_CREATE_FOLLOW_UP);
export const successCreatingFollowUp = createAction(SUCCESS_CREATING_FOLLOW_UP, payload => payload, () => ({
  notification: {
    type: 'info',
    message: I18n.text('automationLib.createYourOwnSection.followUpCreated')
  }
}));
export const failCreatingFollowUp = createErrorAction(FAIL_CREATING_FOLLOW_UP, 'automationLib.errorMessages.failCreatingFollowUp');
const createNewFollowUpEmail = () => (dispatch, getState) => {
  const state = getState();
  const applicationName = getApplicationName(state);
  const guid = getGuid(state);
  dispatch(requestCreateFollowUp());
  let sourceApp;
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      sourceApp = SOURCE_APP.LEAD_FLOWS_APP;
      break;
    case APPLICATION_NAMES.FORMSUI:
    default:
      sourceApp = SOURCE_APP.FORMS_APP;
      break;
  }
  return postAddNewFollowUpEmail(guid, sourceApp /*workflowTrigger*/).then(payload => {
    dispatch(successCreatingFollowUp(payload));
  }).catch(error => {
    dispatch(failCreatingFollowUp(error));
  });
};
export default createNewFollowUpEmail;